export const OperationTypes = {
  HTTP: 'HTTP',
  SIGNALR: 'SignalR',
} as const;

export type OperationType = typeof OperationTypes[keyof typeof OperationTypes];
